import {centsFromDecimal} from './domain.js';

// Currency is edited as integer centavos, never with floating-point decimals.
// A controlled MoneyInput always presents pt-BR grouping and two decimal places.
export const MAX_INPUT_CENTS=99999999999;
export function brlCentsToText(value){
  const cents=Number(value);
  const safe=Number.isFinite(cents)?Math.min(MAX_INPUT_CENTS,Math.max(0,Math.trunc(cents))):0;
  return new Intl.NumberFormat('pt-BR',{minimumFractionDigits:2,maximumFractionDigits:2}).format(safe/100);
}
export function brlTextFromValue(value){
  return brlCentsToText(centsFromDecimal(value));
}
export function brlTextFromDigits(raw){
  const digits=String(raw??'').replace(/\D/g,'');
  if(!digits)return brlCentsToText(0);
  return brlCentsToText(Math.min(MAX_INPUT_CENTS,Number(digits)));
}
export function brlAppendDigit(current,digit,replace=false){
  if(!/^[0-9]$/.test(String(digit)))return brlTextFromValue(current);
  const cents=replace?0:centsFromDecimal(current);
  return brlCentsToText(Math.min(MAX_INPUT_CENTS,cents*10+Number(digit)));
}
export function brlDeleteDigit(current,clear=false){
  return brlCentsToText(clear?0:Math.floor(centsFromDecimal(current)/10));
}
export function brlTextFromPaste(raw){
  const text=String(raw??'').trim();
  if(!text)return '0,00';
  // Paste of an integer means reais; paste of 12,30 or 12.30 means decimals.
  if(/^\d+$/.test(text))return brlCentsToText(Number(text)*100);
  return brlTextFromValue(text.replace(/[^0-9,.-]/g,''));
}
